export default "__VITE_ASSET__BLX7VKfH__"